import { ModalContent, StyledPopup } from './style';
interface DisplayModalProps {
  open: boolean;
  handleClose: () => void;
  children?: React.ReactNode;
  className?: string; 
}

export default function DisplayModal({ open, handleClose, children, className }: DisplayModalProps) {

	return (
		<StyledPopup
			open={open}
			closeOnDocumentClick={true}
			onClose={handleClose}
			className={`${open ? 'open' : 'close'} ${className || ''}`} 
			position={'bottom center'}
			nested={true}
		>
			<ModalContent className="modal-content">
				{children}
			</ModalContent>
		</StyledPopup>
	);
}
